/*
 * The chip another surface asked the Activity page to open with.
 *
 * `Ctrl+K ▸ Threads` and *More ▸ Threads* are not a place of their own: they are the feed under its
 * *Replies* chip, which is the threads view (X-A4 N2, G-53). A navigation carries no state, so the
 * asking surface leaves the chip here and the page picks it up on its first render — the same
 * hand-over `core/search/searchState.ts` makes for a prepared query, and for the same reason: what
 * belongs to one tab's next screen is not a route parameter.
 *
 * Unlike the search term, a chip *may* stand in the address — `/activity?filter=reply` is a link
 * worth pasting, and it names a view rather than something somebody typed — so the page reads both,
 * and this module exists for the one case where there is no navigation to put it in.
 *
 * A read consumes it: a chip that has been handed over has been used, and a stale hand-over must not
 * move the reader off the tab they chose afterwards.
 */

import { readSessionValue, writeSessionValue } from "../../lib/storage.ts"

/** The tab's own scratch value, like the prepared search term beside it. */
const KEY = "tb.activity.filter"

/** The chip a surface prepared, once. */
export function takePendingFilter(): string | undefined {
	const group = readSessionValue(KEY)
	if (group === "") return undefined
	writeSessionValue(KEY, "")
	return group
}

/** Asks the Activity page to open on one chip; the caller then navigates to `/activity`. */
export function setPendingFilter(group: string): void {
	writeSessionValue(KEY, group)
}

/** The chip the threads view is: the group chat registers its reply kind under. */
export const FILTER_REPLIES = "reply"
